import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';

import Vue from 'vue';
import VueOnsen from 'vue-onsenui';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

import './assets/js/common';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
import sanitizeHTML from 'sanitize-html';

import a2hs from './a2hs';
import localDB from './localDB';
import { i18n } from './i18n';

import UtilHelper from './mixins/UtilHelper';
import CommonHelper from './mixins/CommonHelper';
import NotificationHelper from './mixins/NotificationHelper';
import NavigatorHelper from './mixins/NavigatorHelper';
import SharedComponents from './components/shared/index';
import ImgWithPlaceholder from './components/ImgWithPlaceholder';

(() => {
  let html = document.documentElement;
  html.className = 'js';
})();

(() => {
  window.addEventListener('keydown', function(e) {
    if (e.keyIdentifier == 'U+000A' || e.keyIdentifier == 'Enter' || e.keyCode == 13) {
      e.preventDefault();
      return false;
    }
  }, true);
})();

let main = () => {
  let isHTML = (str) => {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  };
  Vue.config.productionTip = false;
  Vue.prototype.$isCordova = !!window.cordova;
  Vue.prototype.$isStandalone = !!(Vue.prototype.$isCordova || (window.matchMedia && window.matchMedia('(display-mode: standalone)') && window.matchMedia('(display-mode: standalone)').matches) || (window.navigator && window.navigator.standalone) || (window.location.search.match(/standalone/i)) || (document.referrer && document.referrer.includes('android-app://')));
  Vue.prototype.$isInApp = !!(Vue.prototype.$isCordova || (window.location.search.match(/in_app/i)));
  window.requireLogin = Vue.prototype.$requireLogin = false;
  Vue.prototype.$a2hs = a2hs;
  Vue.prototype.$firstRun = !parseInt(window.localStorage.getItem('not_first_run') || 0);
  Vue.prototype.$initDarkModeEnabled = !!parseInt(window.localStorage.getItem('init_dark_mode_enabled') || 0);
  Vue.prototype.$sanitizeHTML = (rawHTML) => {
    if (!rawHTML) { return ''; }
    let sanitizedHTML = sanitizeHTML(rawHTML, {
      allowedTags: [ 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', "blockquote", 'div', 'ul', 'ol', 'li', 'p', 'b', 'i', 'em', 'strong', 'a', 'br' ],
      allowedAttributes: {
        a: [ 'href', 'target' ],
      },
      allowedSchemes: [ 'http', 'https' ],
      transformTags: {
        'a': function(tagName, attribs) {
          return {
            tagName: tagName,
            attribs: {
              href: attribs.href,
              target: '_blank',
            }
          };
        }
      }
    });
    if (!isHTML(sanitizedHTML)) {
      sanitizedHTML = '<p>' + sanitizedHTML.split('\n').join('</p><p>') + '</p>';
    }
    return sanitizedHTML;
  };
  window.localStorage.setItem('not_first_run', 1);
  Vue.use(VueOnsen);
  Vue.use(VueAnalytics, {
    id: 'UA-154848763-1',
    autoTracking: {
      prependBase: false,
    },
    router,
    ignoreRoutes: ['splash', 'episode'],
    ready () {
      if (Vue.prototype.$isCordova) {
        Vue.$ga.set('checkProtocolTask', null); Vue.$ga.set('checkStorageTask', null); Vue.$ga.set('historyImportTask', null);
      }
      Vue.$ga.set('dimension1', Vue.prototype.$isCordova ? (window.cordova.platformId === 'android' ? 'edifi-android' : 'edifi-ios') : (Vue.prototype.$isStandalone ? 'edifi-pwa' : 'edifi-web'));
      Vue.$ga.set('dimension2', process.env.VUE_APP_VERSION);
    },
  });

  Vue.mixin(UtilHelper);
  Vue.mixin(CommonHelper);
  Vue.mixin(NotificationHelper);
  Vue.mixin(NavigatorHelper);
  Vue.mixin(SharedComponents);
  Vue.mixin({components: { 'img-with-placeholder': ImgWithPlaceholder, }});

  localDB.init();

  new Vue({
    router,
    store,
    i18n,
    render(h) { return h(App); },
    beforeCreate() {
      this.$ons.disableIconAutoPrefix();

      document.documentElement.setAttribute('edififlag-no-search', '');
      if (this.$isStandalone) {
        document.documentElement.setAttribute('edififlag-standalone', '');
      }
      if(this.$ons.platform.isIOS() || this.$ons.platform.isIPadOS()) {
        document.documentElement.setAttribute('edififlag-ios', '');
      } else {
        document.documentElement.setAttribute('edififlag-not-ios', '');
      }
      if(this.$ons.platform.isAndroid()) {
        document.documentElement.setAttribute('edififlag-android', '');
      } else {
        document.documentElement.setAttribute('edififlag-not-android', '');
      }
      if(this.$ons.platform.isIPhoneX()) {
        if (this.$isInApp) {
          document.documentElement.setAttribute('onsflag-iphonex-portrait', '');
          document.documentElement.setAttribute('onsflag-iphonex-landscape', '');
        } else {
          document.documentElement.setAttribute('onsflag-iphonex-landscape', '');
        }
      }

      // FB pixel
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', '895341354318449');
      window.fbq('track', 'PageView');

      this.$ons.ready(() => {
        if (!!window.cordova && !!window.navigator && !!navigator.splashscreen) {
          navigator.splashscreen.hide();
        }
        this.navigatorInitRoot();
        this.initializeNavigator();
      });

      // handle open id callback
      if (this.$router.currentRoute.name === 'open-id-callback') {
        try {
          window.opener.openIdCallbackHandler(this.$router.currentRoute);
        } catch (err) { }
        window.close();
        return false;
      }

      // handle pwa install prompt
      this.$a2hs.init(this.$ons.platform.isIOS() || this.$ons.platform.isIPadOS(), this.$ons.platform.isAndroid());
    },
    mounted() {
      this.$store.dispatch('player/deviceReady');
    },
  }).$mount('#app');
};

if (!!window.cordova) {
  document.addEventListener('deviceReady', main, false);
} else {
  main();
}
